import './textAreaField.scoped.scss'
import { ChangeEvent, FocusEvent, ReactNode } from "react"
import { FieldLabel } from "components/common/formFields/fieldLabel/fieldLabel"

export interface TextAreaFieldProps {
  label: string | ReactNode
  hint?: string
  name: string
  value: string | number
  isInvalid: boolean
  errors?: string
  onChange: (event: ChangeEvent) => void
  onBlur: (event: FocusEvent) => void
  rows?: number
  autoComplete?: string
}

export const TextAreaField = (props: TextAreaFieldProps) => {
  return (
    <label className="select-field column">
      <FieldLabel label={props.label} hint={props.hint} />
      <textarea
        name={props.name}
        value={props.value}
        rows={props.rows}
        autoComplete={props.autoComplete}
        aria-invalid={props.isInvalid}
        onChange={props.onChange}
        onBlur={props.onBlur}
        className={`input text-area-field ${props.isInvalid ? 'invalid' : ''}`}
      />
      {props.isInvalid && (
        <div className={'validation-error column gap1 mt1'}>
          {props.errors}
        </div>
      )}
    </label>
  )
}

